import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICustomer, IOperator } from 'app/models';
import { OperatorService } from 'app/services';
import { MessageService } from 'app/services/message/message.service';

@Component({
  selector: 'app-operator-mngt-detail',
  templateUrl: './operator-mngt-detail.component.html',
  styleUrls: ['./operator-mngt-detail.component.scss'],
})
export class OperatorMngtDetailComponent implements OnInit {
  @Input() customers: ICustomer[] = [];

  @Output() operatorSaved = new EventEmitter<boolean>();

  operatorForm: FormGroup = this.fb.group({
    id: [undefined],
    code: [null, Validators.required],
    name: [null, Validators.required],
    customerId: [null, Validators.required],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly operatorService: OperatorService,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.initEmpty();
  }

  initEmpty(): void {
    this.operatorForm = this.fb.group({
      id: [undefined],
      code: [null, Validators.required],
      name: [null, Validators.required],
      customerId: [null, Validators.required],
    });
  }

  initEdit(operator: IOperator): void {
    this.operatorForm.setValue({
      id: operator.id ?? null,
      code: operator.code,
      name: operator.name,
      customerId: operator.customerId,
    });
  }

  clear(): void {
    this.operatorForm.reset();
  }

  onSubmit(): void {
    if (!this.operatorForm || this.operatorForm.invalid) {
      return;
    }

    const { id, ...payload } = this.operatorForm.getRawValue();

    if (id) {
      this.operatorService.update(id, payload).subscribe(
        () => {
          this.operatorSaved.emit(true);
          this.clear();
        },
        () => this.messageService.showDirectSimpleMessage(` Operator save error `)
      );
      return;
    }

    this.operatorService.add(payload).subscribe(
      () => {
        this.operatorSaved.emit(true);
        this.clear();
      },
      () => this.messageService.showDirectSimpleMessage(` Operator save error `)
    );
  }
}
